<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <a-select 
                v-if="tenant_id == 1"
                class="query_field" 
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')" 
                :options="tenantOptions" 
                @change="handleSelectChange('tenant')"
            ></a-select>
            <a-select 
                class="query_field" 
                v-model:value="searchForm.frame_number" 
                allowClear
                showSearch
                :placeholder="t('cycling.frameNumber')" 
                :options="frameNumberOptions"
                @change="handleSelectChange('frame_number')"
                @search="(val)=>getFrameAndMotor(val,'frame_number')"
            >
                <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                </template>
            </a-select>
            <a-select 
                class="query_field" 
                v-model:value="searchForm.assembly_code" 
                allowClear
                showSearch
                :placeholder="t('cycling.assemblyCode')" 
                :options="motorCodeOptions" 
                @change="handleSelectChange('assembly_code')"
                @search="(val)=>getFrameAndMotor(val,'assembly_code')"
            >
                <template v-if="fetching" #notFoundContent>
                    <a-spin size="small" />
                </template>
            </a-select>
            <a-button type="primary" size="small" style="margin-right:10px" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
            <a-button type="primary" size="small" style="margin-right:10px" @click="getMileageRank">
                <img src="@/assets/image/chart.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('cycling.mileageRank') }}
            </a-button>
            <!-- <a-button type="primary" size="small" :disabled="!searchForm.frame_number && !searchForm.assembly_code" :loading="exportLoading" @click="downloadUserCyclingListData">
                <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('cycling.downloadUserCyclingListData') }}
            </a-button> -->
        </div>

        <div>
            <div class="table_title">{{ title }}</div>
            <Table
                class="table"
                :table="table"
                @handleChangePagination="handleChangePagination"
            ></Table>
        </div>

        <!-- 数据图表 -->
        <div class="chart_block">
            <a-dropdown v-if="showAll">
                <template #overlay>
                    <a-menu @click="handleMenuClick">
                        <a-menu-item key="1">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadAllUserMileageZoneCount') }}
                        </a-menu-item>
                        <a-menu-item key="2">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadRideCount') }}
                        </a-menu-item>
                    </a-menu>
                </template>
                <a-button type="primary" size="small" >
                    {{ $t('base.exportData') }} <DownOutlined />
                </a-button>
            </a-dropdown>
            <a-dropdown v-else>
                <template #overlay>
                    <a-menu @click="handleMenuClick">
                        <a-menu-item key="3">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadChart1') }}
                        </a-menu-item>
                        <a-menu-item key="4">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadChart2') }}
                        </a-menu-item>
                        <a-menu-item key="5">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadChart3') }}
                        </a-menu-item>
                        <a-menu-item key="6">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadChart4') }}
                        </a-menu-item>
                        <a-menu-item key="7">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadChart5') }}
                        </a-menu-item>
                        <a-menu-item key="8">
                            <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                            {{ $t('cycling.downloadChart6') }}
                        </a-menu-item>
                    </a-menu>
                </template>
                <a-button type="primary" size="small" >
                    {{ $t('base.exportData') }} <DownOutlined />
                </a-button>
            </a-dropdown>
            <div class="chart">
                <!-- 所有用户预计 -->
                <div class="chart_all" v-if="showAll">
                    <!-- 总里程区间数量 -->
                    <div id="torqueChart"></div>
                    <!-- 骑行总次数区间数量 -->
                    <div id="torqueChart2"></div>
                </div>
                

                <!-- 单一用户统计 -->
                <div class="chart_user" v-else>
                    <!-- 电机输出功率 -->
                    <div class="chart_user_item">
                        <div id="torqueChart3"></div>
                        <div class="desc desc1">
                            <div class="desc_item" v-for="(item, index) in percentData.percentData_0" :key="index">
                                <span class="label">{{ item.label }}</span>
                                <span class="value">{{ item.value }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 人踩踏功率 -->
                    <div class="chart_user_item">
                        <div id="torqueChart4"></div>
                        <div class="desc desc2">
                            <div class="desc_item" v-for="(item, index) in percentData.percentData_1" :key="index">
                                <span class="label">{{ item.label }}</span>
                                <span class="value">{{ item.value }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 骑行模式使用 -->
                    <div class="chart_user_item">
                        <div id="torqueChart5"></div>
                        <div class="desc desc3">
                            <div class="desc_item" v-for="(item, index) in percentData.percentData_3" :key="index">
                                <span class="dot" :style="{background: modeColorObj[item.label]}"></span>
                                <span class="label">{{ item.label }}</span>
                                <span class="value">{{ item.value }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 踏频统计 占总骑行时间的比例 -->
                    <div class="chart_user_item">
                        <div id="torqueChart6"></div>
                        <div class="desc desc4">
                            <div class="desc_item" v-for="(item, index) in percentData.percentData_6" :key="index">
                                <span class="label">{{ item.label }}</span>
                                <span class="value">{{ item.value }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 人踩踏扭矩 占总骑行总记录的比例 -->
                    <div class="chart_user_item">
                        <div id="torqueChart7"></div>
                        <div class="desc desc5">
                            <div class="desc_item" v-for="(item, index) in percentData.percentData_5" :key="index">
                                <span class="label">{{ item.label }}</span>
                                <span class="value">{{ item.value }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 电机输出扭矩 占总骑行总记录的比例 -->
                    <div class="chart_user_item">
                        <div id="torqueChart8"></div>
                        <div class="desc desc6">
                            <div class="desc_item" v-for="(item, index) in percentData.percentData_4" :key="index">
                                <span class="label">{{ item.label }}</span>
                                <span class="value">{{ item.value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 查询 -->
        <a-modal 
            v-model:open="visible"
            :closable="false"
            :width="500"
            :cancelText="t('base.cancel')"
            :okText="t('base.confirm')"
            @ok="handleSearch"
        >
            <div class="queryUserTitle">{{ $t('base.search') }}</div>
            <a-select 
                class="frame_input" 
                v-model:value="searchForm.frame_number" 
                allowClear
                showSearch
                :placeholder="t('cycling.frameNumber')" 
                :options="frameNumberOptions"
                @change="handleSelectChange('frame_number')"
            ></a-select>
            <a-select 
                class="frame_input" 
                v-model:value="searchForm.assembly_code" 
                allowClear
                showSearch
                :placeholder="t('cycling.assemblyCode')" 
                :options="motorCodeOptions" 
                @change="handleSelectChange('assembly_code')"
            ></a-select>
        </a-modal>

        <!-- 排行榜 -->
        <a-modal 
            v-model:visible="rankVisible"
            :title="t('cycling.rank')"
            centered
            width="70%"
            :footer="null"
            style="text-align:center;"
        >
            <a-radio-group class="topGroup" v-model:value="rank_top" size="small" button-style="solid"  @change="changeVehicleTopRadio">
                <a-radio-button value="10">{{ $t('cycling.top10') }}</a-radio-button>
                <a-radio-button value="20">{{ $t('cycling.top20') }}</a-radio-button>
                <a-radio-button value="50">{{ $t('cycling.top50') }}</a-radio-button>
                <a-radio-button value="100">{{ $t('cycling.top100') }}</a-radio-button>
            </a-radio-group>

            <!-- <a-button type="primary" size="small" @click="handledownLoadMile" class="downloadMile">
                <component :is="$antIcons['DownloadOutlined']"></component>
                {{$t('cycling.downloadMile')}}
            </a-button> -->

            <div id="vehicleRank"></div>
            <div id="cyclingRank"></div>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue";
    import * as echarts from 'echarts'
    import 'echarts/extension/bmap/bmap';
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRoute, useRouter } from "vue-router";
    import { CyclingApi } from '@/api/CyclingApi.js';
    import { LoginApi } from '@/api/LoginApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate, getFieldVal, exportFile } from '@/utils/global';
    import ApexCharts from 'apexcharts'
    import { multiply, add, subtract, divide } from 'accurate-core';
    

    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const title = ref(t('cycling.totalCyclingStatistics'))
    const visible = ref(false)
    const searchForm = reactive({
        frame_number: null,
        assembly_code: null,
        tenant_id: "",
    })
    const frameNumber = ref('')
    const showAll = ref(true)
    const frameNumberOptions = ref([])
    const motorCodeOptions = ref([])
    const user_id = ref('')
    const vehicle_id = ref('')
    const tenant_id = ref(sessionStorage.getItem('userInfo')? JSON.parse(sessionStorage.getItem('userInfo')).tenant_id : '')
    const exportLoading = ref(false)
    const fetching = ref(false)
    const tenantOptions = ref([])

    const rankVisible = ref(false)
    const rank_top = ref('10')
    const percentData = ref({
        percentData_0: [],
        percentData_1: [],
        percentData_3: [],
        percentData_6: [],
        percentData_5: [],
        percentData_4: [],
    })

    const stat_type_obj = ref({
        0:t('cycling.downloadChart1'),
        1:t('cycling.downloadChart2'),
        3:t('cycling.downloadChart3'),
        6:t('cycling.downloadChart4'),
        5:t('cycling.downloadChart5'),
        4:t('cycling.downloadChart6'),
    })

    const modeColorObj = ref({
        // 'Mode 1': '#1226aa',
        // 'Mode 2': '#a6e7ff',
        // 'Mode 3': '#3678da',
        // 'Mode 4': '#0e5cad',
        // 'Mode 5': '#7dc3ff',

        'OFF': '#1226aa',
        'ECO': '#a6e7ff',
        'TOUR': '#3678da',
        'TURBO': '#0e5cad',
        'SPORT': '#7dc3ff',
        'BOOST': '#f4ad1e',
        'AUTO': '#36d95f',
    })

    const headerData = ref({
        menu:'menu.CyclingData',
        menu_desc: 'menu.subCyclingData',
        week: getWeek().week,
        current_time:getWeek().currentDate,
    })

    const table = ref({
        data: [],
        columns: [
            {
                title: t('cycling.frameNumber'),
                dataIndex: 'frame_number',
                key: 'frame_number',
                width:180,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('cycling.assemblyCode'),
                dataIndex: 'triple_id',
                key: 'triple_id',
                width:160,
                resizable: true,
            },
            {
                title: t('cycling.totalDistance'),
                dataIndex: 'triple_mileage',
                key: 'triple_mileage',
                width:160,
                resizable: true,
            }, 
            {
                title: t('cycling.totalTime'),
                dataIndex: 'cost_time',
                key: 'cost_time',
                width:130,
                resizable: true,
            },
            {
                title: t('cycling.totalRides'),
                dataIndex: 'ride_no',
                key: 'ride_no',
                width:140,
                resizable: true,
            },
            // {
            //     title: t('cycling.trampling_laps'), // 踩踏总圈数
            //     dataIndex: 'trampling_laps',
            //     key: 'trampling_laps',
            //     width:180,
            // },
            {
                title: t('cycling.maxDist'),
                dataIndex: 'maximum_distance',
                key: 'maximum_distance',
                width:220,
                resizable: true,
            }, 
            {
                title: t('cycling.maxCadence'),
                dataIndex: 'highest_cadence',
                key: 'highest_cadence',
                width:210,
                resizable: true,
            },
            {
                title: t('cycling.maxSpeed'),
                dataIndex: 'highest_speed',
                key: 'highest_speed',
                width:180,
                resizable: true,
            },
            // {
            //     title: t('cycling.cyclingMileage'),
            //     dataIndex: 'cycling_mileage',
            //     key: 'cycling_mileage',
            //     width:180,
            //     resizable: true,
            // },
            ...(userInfo.value.tenant_id == 1 ? [
                {
                    title: t('account.tenant'),
                    dataIndex: 'tenant_name',
                    key: 'tenant_name',
                    width: 140,
                    resizable: true,
                    // filters: [
                    //     {
                    //         text: 'GOBAO',
                    //         value: 'GOBAO',
                    //     },
                    //     {
                    //         text: 'HEPHA',
                    //         value: 'HEPHA',
                    //     },
                    //     {
                    //         text: 'Corest',
                    //         value: 'Corest',
                    //     },
                    //     {
                    //         text: 'Birk',
                    //         value: 'Birk',
                    //     },
                    // ],
                    // filterMultiple: false,
                    // onFilter: (value, record) => record.tenant_name.indexOf(value) === 0,
                },
            ] : []),
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                // x: 1500,
                y: 450,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        }
    })


    const handleChangePagination =  (config, data)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handleSelectChange = (type)=>{
        // console.log(type, 'type')
        let item = null
        if(type == 'frame_number'){
            searchForm.assembly_code = null
            item = frameNumberOptions.value.find(item=>item.value == searchForm.frame_number)
        }else if(type == 'assembly_code'){
            searchForm.frame_number = null
            item = motorCodeOptions.value.find(item=>item.value == searchForm.assembly_code)
        }else if(type == 'tenant'){
            searchForm.frame_number = null
            searchForm.assembly_code = null
        }

        if(item){
            frameNumber.value = type == 'frame_number'? item.value : item.frame_number
            user_id.value = item.user_id
            vehicle_id.value = item.vehicle_id
            title.value = ` ${frameNumber.value} ` + t('base.rideData')
        }else{
            frameNumber.value = ''
            user_id.value = ''
            vehicle_id.value = ''
            title.value = t('cycling.totalCyclingStatistics')
            showAll.value = true
        }

        getFrameAndMotor()
        
        table.value.configs.pagination.current = 1
        getList()

        if(!searchForm.frame_number && !searchForm.assembly_code){
            getAllUserMileageZoneCount()
            getCyclingCount()
        }
    }

    const handleSearch = ()=>{
        console.log(frameNumber.value, 'frameNumber.value')
        if(!!frameNumber.value) title.value = `${frameNumber.value} ` + t('base.rideData')
        table.value.configs.pagination.current = 1
        getList()
        
        if(!searchForm.frame_number && !searchForm.assembly_code){
            getAllUserMileageZoneCount()
            getCyclingCount()
        }
    }

    // 下载数据
    const handleMenuClick = (e)=>{
        console.log(e, 'e')
        if(e.key == '1'){
            downloadChart1Data()
        }else if(e.key == '2'){
            downloadChart2Data()
        }else if(e.key == '3'){
            downloadUserCyclingData(0)
        }else if(e.key == '4'){
            downloadUserCyclingData(1)
        }else if(e.key == '5'){
            downloadUserCyclingData(3)
        }else if(e.key == '6'){
            downloadUserCyclingData(6)
        }else if(e.key == '7'){
            downloadUserCyclingData(5)
        }else if(e.key == '8'){
            downloadUserCyclingData(4)
        }
    }

    // 获取车辆列表
    const getList = async ()=>{
        let param = {
            frame_number: searchForm.frame_number || '',
            triple_id: searchForm.assembly_code || '',
            tenant_id: userInfo.value.tenant_id == 1 ? searchForm.tenant_id : userInfo.value.tenant_id,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await CyclingApi.getInstance().getList(param, page_num, page_size)
        if(res && res.code === 0){
            table.value.configs.loading = false
            if(!!searchForm.frame_number || !!searchForm.assembly_code){
                visible.value = false
                showAll.value = false

                let stat_type_arr = ['0', '1', '3', '6', '5', '4']
                stat_type_arr.forEach(item=>{
                    getUserCyclingData(item)
                })
            }else{
                visible.value = false
            }

            let fieldArr = ['triple_id', 'ride_no', 'trampling_laps']
            res.data.records.forEach(item=>{
                item.triple_mileage = item.triple_mileage == undefined? '-' : item.triple_mileage === 0? '0 km' : divide(item.triple_mileage, 1000).toFixed(2) + ' km'
                item.cost_time = item.cost_time == undefined? '-' : item.cost_time === 0? '0 h' : divide(item.cost_time, 3600).toFixed(2) + ' h'    
                item.maximum_distance = item.maximum_distance == undefined? '-' : item.maximum_distance === 0? '0 km' : divide(item.maximum_distance, 1000).toFixed(2) + ' km'
                item.highest_cadence = item.highest_cadence == undefined? '-' : item.highest_cadence === 0? '0 rpm' : item.highest_cadence + ' rpm'
                item.highest_speed = item.highest_speed == undefined? '-' : item.highest_speed === 0? '0 km/h' : item.highest_speed + ' km/h'
                fieldArr.map(m=>{
                    item[m] = getFieldVal(item[m])
                })
            })

            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total
        }else{
            message.error(res.msg || res.message)
        }
    }   

    // 获取车架号、电机总成
    const getFrameAndMotor = async (val,type)=>{
        let param = {   
            tenant_id: userInfo.value.tenant_id == 1 ? searchForm.tenant_id : userInfo.value.tenant_id,
        }
        if(type && type == 'frame_number') param.frame_number = val
        if(type && type == 'assembly_code') param.triple_id = val

        fetching.value = true
        let res = await CyclingApi.getInstance().getFrameAndMotor(param, 1, 50)
        if(res.code === 0){
            fetching.value = false
            frameNumberOptions.value = []
            motorCodeOptions.value = []

            res.data.records.length > 0 && res.data.records.forEach(item=>{
                    if(item.frame_number){
                        frameNumberOptions.value.push({
                            label: item.frame_number,
                            value: item.frame_number,
                            user_id: item.user_id,
                            vehicle_id: item.id,
                        })
                    }
                    if(item.triple_id){
                        motorCodeOptions.value.push({
                            label: item.triple_id,
                            value: item.triple_id,
                            user_id: item.user_id,
                            vehicle_id: item.id,
                            frame_number: item.frame_number,
                        })
                    }
            })
        }else{
            message.error(res.msg || res.message)
        }
    }


    // 全部用户图表
    // 总里程区间人数
    const renderTorqueChart1 = (xAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.totalMileageRangeStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        top:'15%',
                        bottom:'6%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }
    // 骑行总次数区间数量
    const renderTorqueChart2 = (xAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart2')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.totalNumberOfRidesStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        top:'15%',
                        bottom:'6%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }

    // 下载总里程区间人数数据
    const downloadChart1Data = async ()=>{
        let param = [500,1000,2000,4000,7000]
        let res = await CyclingApi.getInstance().downloadAllUserMileageZoneCount(param)
        if (res.status == 200) {
            exportFile(res.data, `${t('cycling.mileageZoneCountData')}.csv`)
            message.success(t('base.downloadSucceeded'))
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg})
            message.success(t('base.downloadFailed'))
        }
    }

    // 下载骑行总次数区间数量数据
    const downloadChart2Data = async ()=>{
        let param = [50,100,200,400,600,900,1200,1500]
        let res = await CyclingApi.getInstance().downloadRideCount(param)
        if (res.status == 200) {
            exportFile(res.data, `${t('cycling.rideCountData')}.csv`)
            message.success(t('base.downloadSucceeded'))
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg})
            message.success(t('base.downloadFailed'))
        }
    }



    // 单一用户图表
    // 电机输出功率
    const renderTorqueChart3 = (xAxisData, yAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart3')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.motorPowerStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        bottom:'3%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value',
                        data: [25,50,75,100],
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar',
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }
    // 人踩踏功率
    const renderTorqueChart4 = (xAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart4')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.totalHumanPowerStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        bottom:'3%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }
    // 骑行模式使用
    const renderTorqueChart5 = (data,stat_type)=>{
        let seriesData = []
        let modeObj = {
            0:'OFF',
            1:'ECO',
            2:'TOUR',
            3:'TURBO',
            4:'SPORT',
            7:'BOOST',
            8:'AUTO',
        }
        data.length > 0 && data.forEach((item,index)=>{
            if ((item.range_min >= 0 && item.range_min <= 4) || (item.range_min == 7 || item.range_min == 8)) {
                seriesData.push({
                    value: item.total_duration,
                    name: modeObj[item.range_min] //`Mode ${item.range_min}`
                })

                percentData.value[`percentData_${stat_type}`].push({
                    label: modeObj[item.range_min], //`Mode ${item.range_min}`,
                    value: item.percent + '%',
                })
            }
        })

        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart5')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.totalShareOfRidingModeUse'),
                        // textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa','#a6e7ff','#3678da','#0e5cad','#7dc3ff','#f4ad1e','#36d95f'],
                    legend: {
                        top: '5%',
                        left: 'center'
                    },
                    grid:{
                        left:'5%',
                        right:'4%',
                        top:'20%',
                        // bottom:'3%',
                        // containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    legend: {
                        orient: 'horizontal',
                        bottom: 0,
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['30%', '50%'],
                            data:seriesData,
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }
    // 踏频统计
    const renderTorqueChart6 = (xAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart6')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.cadenceStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        bottom:'3%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }
    // 人踩踏扭矩统计
    const renderTorqueChart7 = (xAxisData, seriesData)=>{
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart7')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.humanTramplingTorqueStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        bottom:'3%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }
    // 电机输出扭矩统计
    const renderTorqueChart8 = (xAxisData, seriesData)=>{   
        nextTick(() => {
                let myChart = echarts.init(document.getElementById('torqueChart8')) 
                window.addEventListener("resize", () => {
                    myChart.resize();
                })
                myChart.clear()

                let options = {
                    title: {
                        text: t('cycling.motorOutputTorqueStatistics'),
                        textAlign: 'auto',
                        left: '4%',
                    },
                    color:['#1226aa'],
                    grid:{
                        left:'5%',
                        right:'4%',
                        bottom:'3%',
                        containLabel:true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            console.log(value, index, 'value, index')
                            return `${value}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                }
                myChart.setOption(options)
        })
    }


    // 下载电机输出功率-图表
    const downloadUserCyclingData = async (stat_type)=>{
        let param = {
            stat_type: stat_type,
            user_id:user_id.value,
            vehicle_id: vehicle_id.value
        }
        let res = await CyclingApi.getInstance().downloadUserCyclingData(param)
        if (res.status == 200) {
            exportFile(res.data, `${stat_type_obj.value[stat_type]}.csv`)
            message.success(t('base.downloadSucceeded'))
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg})
            message.success(t('base.downloadFailed'))
        }
    }
    // 下载电机输出功率-列表
    const downloadUserCyclingListData = async ()=>{
        let param = {
            frame_number: searchForm.frame_number,
            triple_id: searchForm.assembly_code, 
        }
        exportLoading.value = true
        let res = await CyclingApi.getInstance().downloadUserCyclingListData(param)
        if (res.status == 200) {
            exportFile(res.data, `${t('cycling.downloadRideData')}.csv`)
            exportLoading.value = false
            message.success(t('base.downloadSucceeded'))
        } else {
            Modal.error({ 
                title: t('base.tip'), 
                content: res.msg,
                okText: t('base.ok'),
            })
            exportLoading.value = false
        }
    }



    // 获取总里程区间人数
    const getAllUserMileageZoneCount = async ()=>{
        let param = [500,1000,2000,4000,7000]
        let res = await CyclingApi.getInstance().getAllUserMileageZoneCount(param, searchForm.tenant_id)
        if(res.code === 0){
            res.data = res.data.reverse()

            let xAxisData = [], seriesData = []
            res.data.length > 0 && res.data.forEach((per, index) => {
                xAxisData.push(per.range)
                seriesData.push(per.count)
            })

            renderTorqueChart1(xAxisData, seriesData)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取总骑行次数人数统计
    const getCyclingCount = async ()=>{
        let param = [50,100,200,400,600,900,1200,1500]
        let res = await CyclingApi.getInstance().getRideCount(param, searchForm.tenant_id)
        if(res.code === 0){
            res.data = res.data.reverse()

            let xAxisData = [], seriesData = []
            res.data.length > 0 && res.data.forEach((per, index) => {
                xAxisData.push(per.range)
                seriesData.push(per.count)
            })

            renderTorqueChart2(xAxisData, seriesData)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取单个用户骑行数据
    const getUserCyclingData = async (stat_type)=>{
        let param = {
            stat_type:stat_type, //  0-电机输出功率, 1-人踩踏功率, 2-骑行总功率, 3-骑行模式使用占总骑行时间的比例, 4-电机输出扭矩占总骑行总记录的比例, 5-人踩踏扭矩占总骑行总记录的比例, 6-踏频统计占总骑行时间的比例
            user_id:user_id.value,
            vehicle_id: vehicle_id.value,   
        }
        let res = await CyclingApi.getInstance().getUserCyclingData(param)
        if(res.code === 0){
            res.data = res.data

            let xAxisData = [], yAxisData = [], seriesData = []
            percentData.value[`percentData_${stat_type}`] = []
            const unit = stat_type == '6' ? 'RPM' : (stat_type == '4' || stat_type == '5') ? 'Nm' : 'W'
            res.data.length > 0 && res.data.forEach((per, index) => {
                xAxisData.push(`${per.range_min}~${per.range_max}${unit}`)
                yAxisData.push(per.percent)
                seriesData.push(per.count)

                if(stat_type != '3'){
                    if(index == res.data.length - 1){
                        percentData.value[`percentData_${stat_type}`].push({
                            label: `${per.range_min}${unit}~`,
                            value: per.percent + '%'
                        })
                    }else{
                        percentData.value[`percentData_${stat_type}`].push({
                            label: `${per.range_min}~${per.range_max}${unit}:`,
                            value: per.percent + '%'
                        })
                    }
                    
                }
            })

            if(stat_type == '0'){ // 电机输出功率
                renderTorqueChart3(xAxisData, yAxisData, seriesData)
            }
            if(stat_type == '1'){// 人踩踏功率
                renderTorqueChart4(xAxisData, seriesData)
            }
            if(stat_type == '3'){ // 骑行模式使用
                renderTorqueChart5(res.data, stat_type)
            }
            if(stat_type == '6'){ // 踏频统计
                renderTorqueChart6(xAxisData, seriesData)
            }
            if(stat_type == '5'){ // 人踩踏扭矩统计
                renderTorqueChart7(xAxisData, seriesData)
            }
            if(stat_type == '4'){ // 电机输出扭矩统计
                renderTorqueChart8(xAxisData, seriesData)
            }
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取排行榜
    const getMileageRank = ()=>{
        rankVisible.value = true
        rank_top.value = '10'
        getVehicleRankList(10)
        getCyclingRankList(10)
    }

    const renderVehicleChart = (data)=> {
            let xAxisData = [], seriesData = [], arr = []
            arr = bubbleSort(data)
            arr.forEach((per, index) => {
                per.rank = index + 1
                xAxisData.push(per.frame_number)
                seriesData.push(per.triple_mileage)
            })

            nextTick(() => {
                let myChart = echarts.init(document.getElementById('vehicleRank')) 
                
                window.addEventListener("resize", () => {
                    myChart.resize();
                })

                myChart.clear()
                let option = {
                    title: {
                        text: t('cycling.chartTitle'),
                        textAlign: 'auto',
                        left: '5%',
                        top:'5%'
                    },
                    color:['#1226aa'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            return `${value} km, ${t('base.top')} ${index + 1}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                };

                myChart.setOption(option)
            })
    }

    const renderCyclingChart = (data)=> {
            let xAxisData = [], seriesData = [], arr = []
            arr = bubbleSort(data)
            arr.forEach((per, index) => {
                xAxisData.push(per.email)
                seriesData.push(per.cycling_mileage)
            })

            nextTick(() => {
                let myChart = echarts.init(document.getElementById('cyclingRank'))
                
                window.addEventListener("resize", () => {
                    myChart.resize();
                })

                myChart.clear()
                let option = {
                    title: {
                        text: t('cycling.chartTitle2'),
                        textAlign: 'auto',
                        left: '5%',
                    },
                    color:['#1226aa'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        valueFormatter: (value, index) => {
                            return `${value} km, ${t('base.top')} ${index + 1}` 
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar'
                        }
                    ]
                };

                myChart.setOption(option)
            })
    }

    const changeVehicleTopRadio = ()=>{
        getVehicleRankList()
        getCyclingRankList()
    }

    const bubbleSort = (arr)=> {
        console.log(arr,'arr')
        for (let i = 0; i < arr.length - 1; i++) {
            for (let j = 0; j < arr.length - i - 1; j++) {
                if (Number(arr[j].value) > Number(arr[j + 1].value)) {
                    let temp = arr[j]
                    arr[j] = arr[j + 1]
                    arr[j + 1] = temp
                }
            }
        }
        return arr
    }

    // 下载里程数据
    const handledownLoadMile = async ()=>{
        message.success(t('base.downloading'))
        let res = await CyclingApi.getInstance().downloadMileage(searchForm.tenant_id)
        if (res.status == 200) {
            exportFile(res.data, `${t('cycling.totalMile')}.csv`)
            message.success(t('base.downloadSucceeded'))
        } else {
            Modal.error({ title: t('base.tip'), content: res.msg})
        }
    }

    // 获取车辆排行榜数据
    const getVehicleRankList = async()=>{
        let param = {
            top:rank_top.value,
            sys_org: searchForm.tenant_id
        }
        let res = await CyclingApi.getInstance().getVehicleMileage(param)
        if(res.code === 0){
            renderVehicleChart(res.data)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取车辆排行榜数据
    const getCyclingRankList = async()=>{
        let param = {
            top:rank_top.value,
            sys_org: searchForm.tenant_id
        }
        let res = await CyclingApi.getInstance().getCyclingMileage(param)
        if(res.code === 0){
            renderCyclingChart(res.data)
        }else{
            message.error(res.msg || res.message)
        }
    }

    // 获取租户列表
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            tenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: "",
            })
        }
    }

    onMounted(()=>{
        getList()
        getFrameAndMotor()
        getAllUserMileageZoneCount()
        getCyclingCount()
        getTenantList()
    })
</script>

<style lang="scss" scoped>
.operate_btn{
    margin-top: 30px;
}

.table_title{
    margin: 20px 0;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
}

.chart_block{
    margin: 45px 0 15px;

    .chart{
        margin-top: 5px;

        .chart_all{
            display: flex;

            #torqueChart,
            #torqueChart2{
                margin-top: 10px;
                margin-right: 20px;
                padding: 10px;
                width: 49%;
                height: 400px;
                background: #fff;
                border-radius: 9px;
            }
        }

        .chart_user{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .chart_user_item{
                display: flex;
                padding:20px;
                margin-top: 15px;
                // margin-right: 10px;
                width: 49.5%;
                background: #fff;
                flex-wrap: wrap;
                justify-content: space-between;

                #torqueChart3,
                #torqueChart4,
                #torqueChart5,
                #torqueChart6,
                #torqueChart7,
                #torqueChart8{
                    margin-top: 10px;
                    padding: 10px;
                    width: 60%;
                    height: 300px;
                    background: #fff;
                    border-radius: 9px;
                }

                .desc{
                    padding-left: 20px;
                    width: 40%;
                    border-left: 1px dashed #ccc;
                    font-size:17px;

                    .desc_item{
                        display: flex;
                        margin:5px;

                        .value{
                            display: flex;
                            flex:1;
                            margin-left: 10px;
                            font-weight: 700;
                            text-align: right
                        }
                        .label{
                            display: flex;
                            flex:1;
                        }
                    }
                }

                .desc1,
                .desc2,
                .desc3,
                .desc4,
                .desc5,
                .desc6{
                    align-content: center;
                }

                .desc3{
                    line-height: 50px;
                    
                    .desc_item{
                        .dot{
                            display: inline-block;
                            margin-top: 17px;
                            margin-right: 7px;
                            width: 15px;
                            height: 15px;
                            border-radius: 50%;
                            background: #1226AA;
                        }
                    }
                }
            }

            
        }
    }
}


.queryUserTitle{
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    line-height: 16px;
    color: #1226AA;
}

.query_box{
    margin-top: 30px;
    margin-bottom: 10px;

    .query_field{
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 5px;
        width: 200px;
    }
}


::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}


#vehicleRank{
    margin-top: 60px;
    width: 90%;
    height: 400px
}

#cyclingRank{
    width: 90%;
    height: 400px
}

.topGroup{
    float: left;
    // margin-left: 70px;
    margin-top: -20px;
}

.downloadMile{
    // position: absolute;
    // top: 120px;
    // right: 20px;
    float: right;
    margin-top:-20px;
    // margin-right: 90px;
}

.exportFormItem{
    margin-bottom: 10px;
}
</style>